<!--近七日数据看板-进店客流数-->
<template>
  <Card :bordered="false" class="customflow-container" dis-hover>
    <p slot="title">
      <!-- <slot name="title"></slot> -->
      {{ $t('home.pass_passengerFlow_num') }}
    </p>
    <a href="#" slot="extra">
      <!-- v-if="hasPageAccess('CUSTOMER_FLOW_TREND')" -->
      <Button size="small" type="dashed" class="extra-btn" @click="goToCustom" v-if="hasPageAccess('CUSTOMER_DATA')">
        {{ $t('common.more') }}
        <Icon type="ios-arrow-forward" />
      </Button>
      <slot name="extra"></slot>
    </a>
    <div class="charts-body">
      <!-- <echart :options="options" v-show="!nodata"></echart> -->
      <div id="charts-jd"></div>
      <div class="no-data" v-show="nodata">{{ $t('common.nodata') }}</div>
    </div>
  </Card>
</template>

<script>
import api from '../../../api/home/index';
import * as echarts from 'echarts';
import { privileageAccess } from '../../../mixins/privileage';
export default {
  mixins: [privileageAccess],
  props: {
    tag: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      nodata: false,
      totalSales: 0,
      totalCustomFlow: 0,
      options: {},
      chartLegends: [], //图表图例
      myChart: null,
    };
  },

  created() {
    this.getData();
  },

  methods: {
    myEchartsResize() {
      this.myChart && this.myChart.resize();
    },
    getData() {
      api
        .getFlowTrend()
        .then(res => {
          if (!res.series || res.series.length === 0) {
            this.nodata = true;
          } else {
            this.nodata = false;
            this.initEcharts(res);
          }
        })
        .catch(error => {
          console.error(`${this.$t('home.error_getcustomdata')}：${error}`);
        });
    },

    initEcharts(item) {
      let myChart = echarts.init(document.getElementById('charts-jd'), null, { renderer: 'svg' });
      let option = {
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          top: '8%',
          left: '3%',
          right: '7%',
          bottom: '8%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLine: {
              //坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                color: '#E5E5E5',
              },
            },
            axisLabel: {
              // interval: 0,
              //坐标轴刻度标签的相关设置
              margin: 20,
              color: '#7F7F7F',
            },
            // axisTick: { show: true },
            data: item.categories,
          },
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            // max: 140,
            splitNumber: 7,
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', //虚线
                color: '#F2F2F2',
              },
            },
            axisLine: { show: false },
            axisLabel: {
              margin: 20,
              color: '#7F7F7F',
            },

            axisTick: { show: false },
          },
        ],
        series: [
          {
            name: this.$t('home.customflow'),
            type: 'line',
            smooth: true, //是否平滑曲线显示
            // 			symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            symbolSize: 0,

            lineStyle: {
              color: '#37CCF8', // 线条颜色
            },
            areaStyle: {
              //区域填充样式

              //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                2,
                [
                  { offset: 0.2, color: 'rgba(61,234,255, 0.4)' },
                  { offset: 0.7, color: 'rgba(61,234,255, 0)' },
                ],
                false
              ),

              shadowColor: 'rgba(53,142,215, 0.5)', //阴影颜色
              shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
            },
            data: item.series[0],
            itemStyle : { normal: {label : {show: true}}}
          },
          {
            name: this.$t('home.saledata'),
            type: 'line',
            smooth: true, //是否平滑曲线显示
            // 			symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            symbolSize: 0,

            lineStyle: {
              color: '#FBA155', // 线条颜色
            },
            areaStyle: {
              //区域填充样式

              //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                2,
                [
                  { offset: 0.2, color: 'rgba(251,161,85, 0.4)' },
                  { offset: 0.7, color: 'rgba(251,161,85, 0)' },
                ],
                false
              ),

              shadowColor: 'rgba(53,142,215, 0.5)', //阴影颜色
              shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
            },
            data: item.series[1],
          },
        ],
      };
      // 绘制图表
      myChart.setOption(option);
      this.myChart = myChart;
    },
    goToCustom() {
      this.$system.goRouter({
        router: {
          //路由跳转信息,必填
          // system: ccconstants.SYSTEM_NOS.Web_Angular, //系统编号，用于辨识该功能模块现在做在哪个系统里面
          // url: '/klfx/qs', //跳转路径，需要填写在相应系统里面的路由地址
          // eslint-disable-next-line no-undef
          system: ccconstants.SYSTEM_NOS.Web_People_Counting, //系统编号，用于辨识该功能模块现在做在哪个系统里面
          url: '/passenger-flow/data/fenxi', //跳转路径，需要填写在相应系统里面的路由地址(运营分析-趋势)
        },
      });
    },
  },
};
</script>
<style lang="scss" type="text/scss">
.customflow-container {
  .charts-body {
    @include wh100;
    display: flex;
    align-items: center;
    #charts-jd {
      width: 100%;
      height: 100%;
    }
    .no-data {
      width: 100%;
      height: 30px;
      text-align: center;
      color: #666;
      font-size: 14px;
    }
  }
}
</style>
